import React, { FC } from "react";
import { Calendar as UseCalendarReturnProps } from "../../../hooks/use-calendar/use-calendar";
import { MaskedInputProps } from "../../input";
import { CSS_CLASSES } from "../date-time-input-css-classes";
import { MonthComponent } from "./month";

export interface CalendarOwnProps {
  selectsStart?: boolean;
  selectsEnd?: boolean;
  showOutsideMonthDates?: boolean;
  allowSelectOutsideMonthDates?: boolean;
  color?: MaskedInputProps["color"];
}

export type CalendarPropsFromUserCalendarReturnProps = Pick<
  UseCalendarReturnProps,
  | "months"
  | "getDayProps"
  | "getGridProps"
  | "getPreviousMonthProps"
  | "getNextMonthProps"
  | "getPreviousYearProps"
  | "getNextYearProps"
>;

export type CalendarProps = CalendarOwnProps & CalendarPropsFromUserCalendarReturnProps;

export const Calendar: FC<CalendarProps> = ({
  months,
  getDayProps,
  getGridProps,
  getPreviousMonthProps,
  getNextMonthProps,
  getPreviousYearProps,
  getNextYearProps,
  selectsStart,
  selectsEnd,
  showOutsideMonthDates,
  allowSelectOutsideMonthDates,
  color,
}) => {
  return (
    <div className={CSS_CLASSES.DATE_TIME_INPUT_CALENDAR}>
      {months.map((month, i, months) => (
        <MonthComponent
          key={i}
          month={month}
          showPrevNavigation={i === 0}
          showNextNavigation={i === months.length - 1}
          getDayProps={getDayProps}
          getGridProps={getGridProps}
          getPreviousMonthProps={getPreviousMonthProps}
          getNextMonthProps={getNextMonthProps}
          getPreviousYearProps={getPreviousYearProps}
          getNextYearProps={getNextYearProps}
          selectsStart={selectsStart}
          selectsEnd={selectsEnd}
          showOutsideMonthDates={showOutsideMonthDates}
          allowSelectOutsideMonthDates={allowSelectOutsideMonthDates}
          color={color}
        />
      ))}
    </div>
  );
};
